import { render, staticRenderFns } from "./DeleteMemberProfileAlert.vue?vue&type=template&id=a9bd9848"
import script from "./DeleteMemberProfileAlert.vue?vue&type=script&lang=js"
export * from "./DeleteMemberProfileAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports